export default "__VITE_ASSET__b4f05d9c__"